import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/AppLayout";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import InterventionsList from "@/pages/InterventionsList";
import InterventionForm from "@/pages/InterventionForm";
import InterventionView from "@/pages/InterventionView";
import UsersPage from "@/pages/Users";
import SettingsPage from "@/pages/Settings";
import AccountPage from "@/pages/Account";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950">
      <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function Shell() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/forgot-password" element={user ? <Navigate to="/" replace /> : <ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/interventions" element={<Protected><InterventionsList /></Protected>} />
      <Route path="/interventions/nouveau" element={<Protected><InterventionForm /></Protected>} />
      <Route path="/interventions/:id/edition" element={<Protected><InterventionForm /></Protected>} />
      <Route path="/interventions/:id" element={<Protected><InterventionView /></Protected>} />
      <Route path="/utilisateurs" element={<Protected adminOnly><UsersPage /></Protected>} />
      <Route path="/parametres" element={<Protected adminOnly><SettingsPage /></Protected>} />
      <Route path="/mon-compte" element={<Protected><AccountPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
